import * as Highcharts from "highcharts";
// chart with 2 lines

export const chartData = {
  credits: { enabled: false },
  chart: {
    type: "area"
  },
  title: {
    text: ""
  },
  legend: {
    enabled: true,
    itemMarginTop: 10,
    itemMarginBottom: -20,
    itemStyle: {
      color: "#6b778c",
      "font-weight": "normal"
    }
  },

  xAxis: {
    allowDecimals: false,
    labels: {
      style: { fontSize: "12px" },
      formatter: function() {
        return this.value + "%"; // clean, unformatted number for year
      }
    }
  },
  yAxis: [
    {
      title: {
        text: "Percentage"
      },
      labels: {
        style: { fontSize: "12px" },

        format: "{value}%"
      }
    }
  ],

  tooltip: {
    pointFormat: "{series.name}: <b>{point.y}"
  },
  plotOptions: {
    series: {
      fillOpacity: 0.5
  },
    line: {
      marker: {
        enabled: false
      }
    },
    area: {
      //pointStart:,
      marker: {
        enabled: false,
        symbol: "circle",
        radius: 2,
        states: {
          hover: {
            enabled: true
          }
        }
      }
    }
  },
  series: [
    {
      name: "USA",
      data: [
        28,
        27,
        34,
        
      ]
    },
    {
      name: "USSR/Russia",
      data: [
        60,
        53,
        59,
        
      ]
    },
    {
      type: "line",
      name: "Target",
      showInLegend: false,
      data: [],
      dashStyle: "ShortDash",
      color: "#979797",
      dataLabels: {
        enabled: true,
        formatter: function() {
          if (this.point.x === this.series.data.length - 1) {
            return `Target (${this.y}%)`;
          }
        },
        style: {
          color: "#626262",
          fontSize: "12px",
          fontWeight: "normal"
        }
      }
    }
  ]
};
